import React from 'react';

const BackgroundElements: React.FC = () => {
  return (
    <>
      {/* Animated gradient background */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-indigo-900/20 to-slate-900"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-purple-900/20 via-transparent to-cyan-900/20"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-indigo-600/10 via-transparent to-transparent animate-pulse"></div>
      </div>

      {/* Floating shapes */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-20 h-20 bg-gradient-to-br from-indigo-500/10 to-purple-600/10 rounded-full animate-float"></div>
        <div className="absolute top-40 right-20 w-32 h-32 bg-gradient-to-br from-cyan-500/10 to-blue-600/10 rounded-full animate-float-delayed"></div>
        <div className="absolute bottom-20 left-20 w-16 h-16 bg-gradient-to-br from-pink-500/10 to-rose-600/10 rounded-full animate-float-slow"></div>
        <div className="absolute top-60 left-1/3 w-24 h-24 bg-gradient-to-br from-emerald-500/10 to-teal-600/10 rounded-full animate-float"></div>
        <div className="absolute bottom-40 right-1/4 w-28 h-28 bg-gradient-to-br from-violet-500/10 to-purple-600/10 rounded-full animate-float-delayed"></div>
        
        {/* Simple dot pattern instead of complex SVG */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle, #334155 1px, transparent 1px)',
            backgroundSize: '60px 60px',
            opacity: 0.05
          }}></div>
        </div>
      </div>
    </>
  );
};

export default BackgroundElements;